module.exports = __webpack_public_path__ + "img/seabrokersRoundIcon.3d94234f.png";